import { AxiosInstance } from 'axios';

import { seasonsEndpoints } from '../../utils/constants';
import { axios } from '../axiosInstance';

import { SeasonType } from './SeasonsApi.schema';

class SeasonsApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  getActiveSeasons = async (): Promise<SeasonType> => {
    return this.#requestInstance.get(seasonsEndpoints.seasons);
  };
}

export const seasonsApi = new SeasonsApi(axios);
